import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';

import {
    type AgentCatalogVersion,
    AgentToolsInventoryPage,
} from '@apps/web/components/admin/agent_tools_inventory/agent_tools_inventory_page';

const agentToolsSearchSchema = z.object({
    catalog: z.enum(['v2', 'v3']).catch('v2'),
});

export const Route = createFileRoute('/_app/admin/agent-tools')({
    validateSearch: agentToolsSearchSchema,
    head: () => ({
        meta: [{ title: 'Agent Tool Catalog | Phoebe Admin' }],
    }),
    component: AgentToolsRoute,
});

function AgentToolsRoute() {
    const { catalog } = Route.useSearch();
    const navigate = Route.useNavigate();

    const handleCatalogChange = useCallback(
        (nextCatalog: AgentCatalogVersion) => {
            void navigate({
                search: (previous) => ({
                    ...previous,
                    catalog: nextCatalog,
                }),
            });
        },
        [navigate],
    );

    return (
        <AgentToolsInventoryPage
            catalog={catalog}
            onCatalogChange={handleCatalogChange}
        />
    );
}
